module.exports = __webpack_public_path__ + "img/christmas-offer-paywall-bg.c3a4d308.png";